/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Tool_AcceptedInputs */

const en_mcp_demo_tool_accepted = /** @type {(inputs: Mcp_Demo_Tool_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted`)
};

const es_mcp_demo_tool_accepted = /** @type {(inputs: Mcp_Demo_Tool_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptado`)
};

/**
* | output |
* | --- |
* | "Accepted" |
*
* @param {Mcp_Demo_Tool_AcceptedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_tool_accepted = /** @type {((inputs?: Mcp_Demo_Tool_AcceptedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Tool_AcceptedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_tool_accepted(inputs)
	return en_mcp_demo_tool_accepted(inputs)
});